import React from 'react';

export type PeriodSectionProps = {
  title: string;
  badge: React.ReactNode;
  summary?: string;
  highlight?: boolean;
  headerAction?: React.ReactNode;
  children: React.ReactNode;
};

export function PeriodSection({
  title,
  badge,
  summary,
  highlight,
  headerAction,
  children,
}: PeriodSectionProps) {
  return (
    <div
      className={[
        'rounded p-3 p-md-4 mb-3',
        'bg-gray-800',
        highlight ? 'border border-primary border-opacity-50' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="d-flex flex-wrap align-items-start justify-content-between gap-2">
        <div>
          <div className="d-flex align-items-center flex-wrap gap-2">
            <h3 className="h5 mb-0 text-white">{title}</h3>
            {badge}
          </div>
          {summary ? (
            <p className="text-weak small mt-2 mb-0">{summary}</p>
          ) : null}
        </div>
        {headerAction}
      </div>
      <div className="mt-3">{children}</div>
    </div>
  );
}

export function ReadOnlyTimeTile({
  label,
  valueFormatted,
}: {
  label: string;
  valueFormatted: string;
}) {
  return (
    <div className="rounded p-3 bg-dark bg-opacity-25">
      <div className="text-uppercase txt--sml text-weak">{label}</div>
      <div className="mt-1 fw-medium text-white">{valueFormatted}</div>
    </div>
  );
}
